<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" />
      <div>大会活动</div>
    </div>
    <div class="listBox" v-if="list != null && list.length > 0">
      <div
        class="activity_item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetailHandle(item.Url)"
      >
        <van-image fit="cover" :src="item.Cover" />
        <div class="ai_right">
          <div class="title overFlowTwo">{{ item.Title }}</div>
          <div>
            <div>大会时间：{{ item.Time }}</div>
            <div>参与方式：{{ item.Remarks }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="noActivity" v-else>
      <span class="iconfont icon-kulian"></span>
      <div>内容正在整理中，晚些时候更新.....</div>
    </div>
  </div>
</template>
<script>
import { Image } from "vant";
import { getExhibitionActivityList } from "@/api/index";
export default {
  name: "expoActivity",
  components: {
    "van-image": Image,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    toDetailHandle(url) {
      if (url.split(":")[0] == "https") {
        window.location.href = url;
      }
    },
  },
  mounted() {
    var that = this;
    getExhibitionActivityList().then((res) => {}, (err) => {
      that.list = err.List && err.List.length > 0 ? err.List : [];
    });
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: #f5f5f5;
  .top-box {
    width: 375px;
    height: 103px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    div {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 23px;
      font-weight: bold;
    }
  }
  .listBox {
    .activity_item {
      background: #fff;
      margin-bottom: 10px;
      color: #666660;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      /deep/.van-image {
        width: 140px;
        height: 100px;
        display: block;
      }
      .ai_right {
        width: 206px;
        min-height: 100px;
        color: #333;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        div {
          font-size: 12px;
          line-height: 18px;
        }
        .title {
          font-size: 18px;
          font-weight: 600;
          line-height: 25px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .noActivity {
    min-height: 70vh;
    padding-top: 60px;
    color: #999999;
    font-size: 13px;
    text-align: center;
    background: #fff;
    padding-bottom: 60px;
    .icon-kulian {
      font-size: 100px;
      color: #999;
    }
  }
}
</style>
